export default __webpack_public_path__ + "static/media/IvyRemovalBanding.e4afe33f.jpg";